// Generated by scripts/update-seeq-icons.js from src/svg/seeq/capsule-set.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcCapsuleSet = {
  prefix: 'fak',
  iconName: 'capsule-set' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e90a',
    'M256 158.7c5.1-20.5 25.6-30.7 46.1-25.6 10.2 5.1 20.5 15.4 20.5 30.7l81.9 568.4 66.5-163.9v-501.7c0-35.8-30.7-66.6-66.5-66.6h-245.8c-35.8 0-66.6 30.7-66.5 66.6v240.6l76.8 215 87-363.5zM425 870.4c-5.1 10.2-15.4 20.5-30.8 20.5 0 0-5.1 0-5.1 0-15.4 0-25.6-15.4-30.7-30.7l-76.8-512-71.7 302c-5.1 15.4-15.4 25.6-30.7 25.6s-30.7-5.1-35.8-20.4l-51.2-143.4v445.4c0 35.8 30.7 66.6 66.5 66.6h245.8c35.8 0 66.6-30.7 66.5-66.6v-209.9l-46 122.9zM711.7 158.7c5.1-20.5 25.6-30.7 46.1-25.6 10.2 5.1 20.5 15.4 20.4 30.7l82 568.4 66.5-163.9v-501.7c0-35.8-30.7-66.6-66.5-66.6h-245.8c-35.8 0-66.6 30.7-66.6 66.6v240.6l76.8 215 87.1-363.5zM880.6 870.4c-5.1 10.2-15.4 20.5-30.7 20.5 0 0-5.1 0-5.1 0-15.4 0-25.6-15.4-30.7-30.7l-76.8-512-71.7 302c-5.1 15.4-15.4 25.6-30.7 25.6s-30.7-5.1-35.9-20.4l-51.2-143.4v445.4c0 35.8 30.7 66.6 66.6 66.6h245.8c35.8 0 66.6-30.7 66.5-66.6v-209.9l-46.1 122.9z',
  ],
} satisfies IconDefinition;
